import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";

export type ExactFailedInvoiceID = number;

export interface ExactFailedInvoice {
  created_on: string;
  id: ExactFailedInvoiceID; // Identifier of the failed invoice
  dealer_location_id?: DealerLocationID; // Identifier of the linked location
  dealer_id: DealerID; // Identifier of the linked dealer
  request_body: string; // RequestBody to create this invoice in Exact
}
